<template>
  <v-container
    id="ordini"

    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <base-material-card
      v-if="steporder.codlin>0"
      icon="mdi-cart-plus"
      class="px-5 py-3"
      width="100%"
      :title="`Ordine Linea ${$linea().title}`"
    >
      <v-row justify="end">
        <v-btn
          small
          @click="resetOrder"
        >
          <v-icon>
            mdi-delete
          </v-icon> reset ordine
        </v-btn>
      </v-row>
      <!--
      "CLASSIC" => 3,
        "Carnet CLASSIC" => 29,
        "CLIP-ON" => 4,
        "JOY" => 11,
        "Carnet JOY" => 30,
        "JOYBAB" => 18,
        "INFACE" => 19,
        "CONTUR" => 22,
        "VARIUS" => 25,
        "EC" => 1,
        "LK" => 5,
        "L2" => 6,
        "FL" => 7,
        "CF" => 8,
        "RB" => 9,
        "CH" => 12,
        "EM" => 13,
        "BA" => 14,
        "FP" => 15,
        "FA" => 21,
      -->

      <workflow-swf
        v-if="$linea().codlin==3"
        :carnet="steporder.carnet"
        @clearLinea="openFlow(0)"
        @viewCarnet="viewCarnet"
        @stdOrder="stdOrder"
      />
      <workflow-contur
        v-else-if="$linea().codlin==22"
        :carnet="steporder.carnet"
        @clearLinea="openFlow(0)"
        @viewCarnet="viewCarnet"
        @stdOrder="stdOrder"
      />
      <workflow-joy
        v-else-if="$linea().codlin==11"
        :carnet="steporder.carnet"
        @clearLinea="openFlow(0)"
        @viewCarnet="viewCarnet"
        @stdOrder="stdOrder"
      />
      <workflow-joybab
        v-else-if="$linea().codlin==18"
        :carnet="steporder.carnet"
        @clearLinea="openFlow(0)"
        @viewCarnet="viewCarnet"
        @stdOrder="stdOrder"
      />
      <workflow-clp
        v-else-if="$linea().codlin==4"
        :carnet="steporder.carnet"
        @clearLinea="openFlow(0)"
        @viewCarnet="viewCarnet"
        @stdOrder="stdOrder"
      />
      <workflow-grv
        v-else-if="$linea().codlin==9999"
        @clearLinea="openFlow(0)"
        @stdOrder="stdOrder"
      />
      <v-card-text v-else>
        <v-row justify="center">
          <div class="text-h2 font-weight-light">
            Procedura per ordine On-Line non ancora attivo per linea {{ $linea().codlin }} {{ $linea().title }}
          </div>
        </v-row>
      </v-card-text>
    </base-material-card>

    <base-material-card
      v-else
      icon="mdi-cart-plus"
      class="px-5 py-3"
      width="100%"
    >
      <!-- {{ cliente }} -->
      <v-row justify="center">
        <div class="text-h2 font-weight-light">
          Selezione linea occhiale per il tuo ordine
        </div>
      </v-row>
      <v-row
        v-if="clidata "
        justify="center"
        class="my-5 "
      >
        <v-col
          v-for="line in listaLinee"
          :key="`linea_${line.codlin}`"
          cols="12"
          md="4"
        >
          <v-card
            class="text-center"
            @click="openFlow(line)"
          >
            <v-img
              class="mx-auto"
              :src="`./img/linee/${line.codlin}_${line.label}.png`"
              width="250"
              contain
            />

            {{ line.title }}
          </v-card>
        </v-col>
      </v-row>
    </base-material-card>

    <v-dialog
      v-model="dialogCarnet"
      scrollable
      max-width="1024"
      persistent
    >
      <v-card>
        <v-col>
          <v-row no-gutters>
            <span class="text-h2 font-weight-light">Carnet Disponibili </span>
            <v-spacer />
            <!----> <v-btn
              x-small
              fab
              @click="dialogCarnet = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-divider />
        <v-card-text>
          Seleziona il Carnet che desideri utilizzare
          <v-data-table
            v-if="listaCarnet.length>0"
            v-model="carnetSelected"
            class="my-6"
            mobile-breakpoint="0"
            disable-pagination
            hide-default-footer
            dense
            :items="listaCarnet"
            :headers="headers_carnet"
            item-key="CNEF_NUMERO"
            :single-select="true"
            show-select
          >
            <template v-slot:item.account="{item}">
              {{ clidata.anacli.flgcne==1?(item.CNEF_CODDES==0?'C/o Sede principale':''):'' }}
            </template>
          </v-data-table>
          <template v-if="carnetSelected[0]">
            <v-row

              class="mt-2 pa-4 text-body-3"
            >
              Per l'ordine utilizza il carnet {{ carnetSelected[0].CNEF_NUMERO }} buono nr {{ carnetSelected[0].NEXT_ORBF_BUONO }}
            </v-row>
            <v-row justify="center">
              <v-btn
                color="red"
                class="ma-1"
                text

                @click="setCarnet('none')"
              >
                No
              </v-btn>
              <v-btn
                color="primary"
                class="ma-1"

                @click="setCarnet()"
              >
                Sì
              </v-btn>
            </v-row>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogOrdSospeso"
      scrollable
      max-width="600"
      persistent
    >
      <v-card>
        <v-card-text class="text-center text-h3">
          <v-icon
            class="mr-4"
            large
            color="red"
          >
            mdi-glasses
          </v-icon> Hai un ordine in sospeso, vuoi proseguire?
        </v-card-text>
        <v-card-actions class="text-center">
          <v-divider />

          <v-btn
            color="red"
            class="ma-1"
            text
            @click="dialogOrdSospeso = false; resetOrder()"
          >
            No
          </v-btn>
          <v-btn
            color="primary"
            class="ma-1"
            @click="dialogOrdSospeso = false"
          >
            Sì
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="!clidata || loading">
      <v-row
        justify="center"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import WorkflowGrv from '@/views/Ordine/component/WorkflowGrv'
  import WorkflowSwf from '@/views/Ordine/component/WorkflowSwf'
  import WorkflowJoy from '@/views/Ordine/component/WorkflowJoy'
  import WorkflowJoybab from '@/views/Ordine/component/WorkflowJoybab'
  import WorkflowClp from '@/views/Ordine/component/WorkflowClp'
  import WorkflowContur from '@/views/Ordine/component/WorkflowContur'

  import engine from '@/plugins/engine'
  // import Config from '@/config.js'

  export default {
    name: 'Ordini',
    components: {
      WorkflowGrv,
      WorkflowSwf,
      WorkflowJoy,
      WorkflowJoybab,
      WorkflowClp,
      WorkflowContur,
    },
    data () {
      return {
        loading: false,
        listaLinee: [],
        steporder: {},
        listaCarnet: [],
        dialogCarnet: false,
        dialogOrdSospeso: false,
        carnetSelected: [],
        headers_carnet: [
          { text: 'Numero', value: 'CNEF_NUMERO', align: 'center ', sortable: false },
          { text: 'Fatt.', value: 'CNEF_NUMFAT', align: 'center', sortable: false },
          { text: 'Q.ta disp.', value: 'DISP_CARNET', align: 'center', sortable: false },
          { text: 'Scadenza', value: 'CNEF_DATSCA', align: 'center', sortable: false },
          { text: 'Marca Lente', value: 'CNEF_SMARCA', align: 'center', sortable: false },
          { text: 'Tipo Lente', value: 'CNEF_SGLLEN', align: 'center', sortable: false },
          { text: 'Buono Nr.', value: 'NEXT_ORBF_BUONO', align: 'center', sortable: false },
          { text: 'Account', value: 'account', align: 'center text-no-wrap', sortable: false },
          { text: '', value: 'action', align: 'center', sortable: false },

        ],
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)

      this.steporder = Object.assign({}, this.order)
      if (this.steporder.carnet) {
        this.$store.commit('setCarnet', this.steporder.carnet)
      }

      var codsog = this.auth.userinfo.codsog
      var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
      var codcli = `${codsog}${coddes}`
      console.log('analisi cliData', this.clidata)
      this.steporder.codice = codcli
      this.steporder.email_cliente = this.auth.userinfo.user_email
      this.steporder.ragsoc = this.clidata.anacli.ragsoc
      this.steporder.indirizzo = (this.clidata.anacli.indiri_1 + ' ' + this.clidata.anacli.indiri_2 + ' ' + this.clidata.anacli.locali + ' (' + this.clidata.anacli.sglprv + ')').trim()
      this.steporder.step = 1
      this.listaLinee = this.clidata.anlin
      console.log('lista linee in app', this.listaLinee)
      if (Object.keys(this.order).length > 0) {
        this.dialogOrdSospeso = true
      }
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },

      openFlow (line) {
        // patch per redirect greenvision
        if (line.codlin === 9999) {
          window.location.href = 'https://herzach.eyeconfort.it/'
          return
        }

        this.$set(this.steporder, 'codlin', line.codlin)
        this.$set(this.steporder, 'codart', line.label)
        this.$store.commit('setOrder', this.steporder)
        this.loadCarnet(line)
      },
      loadCarnet (line) {
        console.log('loadCarnet', line)
        if (!line || ![3, 11].includes(+line.codlin)) {
          return
        }
        this.loading = true
        engine.get_listacarnet(line)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
            }
            console.log('RESULT', result)
            this.listaCarnet = result.data
            if (this.listaCarnet.length > 0) {
              this.carnetSelected.push(this.listaCarnet[0])
              this.dialogCarnet = true
            } else {
              this.$store.commit('setSnack', { message: 'Non hai Carnet disponibili', color: '#c54747d4', timeout: 3000 })
            }
          })
          .catch((errore) => {
            console.err('errore: ', errore)
          })
          .finally(() => { this.loading = false })
      },
      setCarnet (action) {
        if (action === 'none') {
          this.$store.commit('setCarnet', null)
        } else {
          this.$store.commit('setCarnet', this.carnetSelected[0])
        }
        this.dialogCarnet = false
        this.carnetSelected = []
      },
      viewCarnet () {
        if (this.listaCarnet.length === 0) {
          this.loadCarnet(this.$linea())
        } else {
          this.carnetSelected.push(this.listaCarnet[0])
          this.dialogCarnet = true
        }
      },
      resetOrder () {
        this.steporder = {}
        this.$store.commit('setOrder', {})
        this.$store.commit('setCarnet', null)

        var codsog = this.auth.userinfo.codsog
        var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
        var codcli = `${codsog}${coddes}`
        console.log('analisi cliData', this.clidata)
        this.steporder.codice = codcli
        this.steporder.email_cliente = this.auth.userinfo.user_email
        this.steporder.ragsoc = this.clidata.anacli.ragsoc
        this.steporder.indirizzo = (this.clidata.anacli.indiri_1 + ' ' + this.clidata.anacli.indiri_2 + ' ' + this.clidata.anacli.locali + ' (' + this.clidata.anacli.sglprv + ')').trim()
        this.steporder.step = 1
      },
      stdOrder () {
        console.log('stdOrder')
        this.loading = true
        engine.stdOrder()
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              return
            }
            // this.saveOrder(result.order)
            this.$store.commit('setSnack', { message: 'Ordine acquisito', color: '#4caf50' })
            this.resetOrder()
          })
          .catch((errore) => {
            console.log('api err: ', errore)
          }).finally(() => { this.loading = false })
      },
      // saveOrder (order) {
      //   console.log('saveOrder')
      //   this.loading = true
      //   engine.saveOrder(order)
      //     .then(result => {
      //       if (result.error) {
      //         this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
      //       }
      //       this.$store.commit('setSnack', { message: result.message, color: '#4caf50' })
      //     })
      //     .catch((errore) => {
      //       console.log('api err: ', errore)
      //     }).finally(() => { this.loading = false })
      // },
    },

  }
</script>
<style>
.uppercase-text input {
  text-transform: uppercase;
}

</style>
